import { Injectable } from '@angular/core';
import { Servicejob } from 'src/app/_model/servicejob';
import { TagTemplateElement } from 'src/app/_model/tag-template-element';
import { Resetable } from '../../resetter/resetable';

@Injectable()
export abstract class TagTemplatesElementsDaoService implements Resetable {
  abstract saveTagTemplatesElements(tagTemplatesElements: TagTemplateElement[]): Promise<void>;
  abstract getTagTemplatesElements(): Promise<TagTemplateElement[]>;
  abstract getTagStatesForPhotodocForCurrentServiceJob(currentJob: Servicejob, tagTemplateELements: TagTemplateElement[]): Promise<void>;
  abstract reset(): Promise<void>;
  abstract clear(): Promise<void>;
}